import React from "react";
import { Grid, InputAdornment } from "@mui/material";
import InfoButton from "./InfoButton";
import { ComoInput } from "../Common/ComoInput";

interface FormTextFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  info: string;
  minRows?: number;
  maxRows?: number;
  error?: boolean;
  helperText?: string;
}

const FormTextField: React.FC<FormTextFieldProps> = ({
  label,
  name,
  value,
  onChange,
  info,
  minRows,
  maxRows,
  error,
  helperText,
}) => {
  return (
    <Grid item xs={12}>
      <ComoInput
        placeholder={label}
        name={name}
        value={value}
        onChange={onChange}
        minRows={minRows}
        maxRows={maxRows}
        margin="normal"
        error={error}
        helperText={helperText}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <InfoButton info={info} />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};

export default FormTextField;
